/**
 * @flow
 */

import React from 'react';
import { Select } from 'semantic-ui-react';
import { range, map } from 'lodash';
import { format, addMinutes, startOfDay } from 'date-fns';

const setupTimeSpans = () =>
    // 12 hour range with step 30 minutes including end of range
    map(range(1, (12 * 60) / 30 + 1), i => {
        const fmt = 'HH:mm';
        const value = i * 30;
        const text = format(addMinutes(startOfDay(new Date()), value), fmt);
        return {
            key: i,
            value,
            text,
        };
    });

const SeminarDuration = ({ meta, ...props }) => (
    <Select {...props} options={setupTimeSpans()} />
);

export default SeminarDuration;
